import Ajv from 'ajv'
import metaSchema from 'ajv/lib/refs/json-schema-draft-07.json'

import {isEmpty, groupBy, repeat, map} from 'lodash'

const createSchema4Ajv = (options) => {
  const ajv = new Ajv({
    schemaId: 'auto', ...options
  })

  ajv.addMetaSchema(metaSchema)

  return ajv
}

const formatErrors = errors =>
  map(
    groupBy(errors, 'instancePath'),
    (groupErrors, groupName) => {
      const errorsString = groupErrors
        .map(({message, params}) => {
          const paramsString = !isEmpty(params) ? `\n${JSON.stringify(params)}` : ''
          return `${message}.${paramsString}`
        })
        .join('\n\n')
      const decorator = repeat('-', groupName.length + 4)
      return `${decorator}\n    ${groupName}\n${decorator}\n\n${errorsString}`
    }
  ).join('\n\n')

export const createValidationForSchema = (schema, createSchemaOptions) => {
  const ajv = createSchema4Ajv({/*allErrors: true, */...createSchemaOptions})
  const validator = ajv.compile(schema)

  const validation = powtoon => {
    if (validator(powtoon)) {
      return null
    }

    const errors = validator.errors.reverse()
    return {errors, errorMessage: `Total errors: #${errors.length}:\n\n${formatErrors(errors)}`}
  }

  return validation
}
